export const phoneNumber = "+55 (27) 99972-5933";

export const email = "contato@eneinteligencia.com.br";

export const instagram = "eneinteligencia";

export const linkedin = "eneinteligencia";
